import { sanitizeUrl } from "@braintree/sanitize-url";
import { getProjectFromDirectory } from "../core/project/projectslist";
import { getDomainCfg } from "../core/state";
import { QueryParams } from "../core/types";
import { getViewName, getViewState, setComponentData } from "../core/views";
import { showError } from "./actions";
import { getRandomElement } from "./utils";
import { randomColor } from "randomcolor";
import { names, setupPartyProvider, updateLocalUser } from "./collaboration/party";
import { LIST_VIEW_NAME, PARTY_USER_STATE } from "../core/constants";
import { getViewData } from "../core/views";

const PROJECT_PARAM = "sp";
const VIEW_PARAM = "vw";
const CATEGORY_PARAM = "ck";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const DOMAIN_PARAM = "d";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const LANG_PARAM = "lang";

export const PARTY_PARAM = "party";

export async function getQueryParams() : Promise<QueryParams> {
  const queryParams : QueryParams = {
    projectParamEnabled : getDomainCfg().projectSettings.urlParamEnabled,
    project : "",
    viewParamEnabled : getDomainCfg().projectSettings.viewParamEnabled,
    view : "",
    collaborationEnabled : getDomainCfg().viewSettings.features.collaborationEnabled,
    party : "",
    categoryFilterEnabled : getDomainCfg().viewSettings.features.categoryFilterEnabled,
    categoryFilter : "",
    quest : null
  }
  const searchParams = window.location.search;
  const urlParams = new URLSearchParams(searchParams);
  const providedUrl = sanitizeUrl(searchParams);

  if (urlParams.has(VIEW_PARAM) && queryParams.viewParamEnabled) {
    const param : string = urlParams.get(VIEW_PARAM) || "";
    const viewFromList = getViewName(param);
    if (!viewFromList) {
      showError('VIEW_NOT_FOUND');
      return {} as QueryParams;
    }

    queryParams.view = viewFromList;
  }

  if (urlParams.has(PROJECT_PARAM) && queryParams.projectParamEnabled /*&& state.configuration.projectId === undefined*/) {
    // https://github.com/braintree/sanitize-url/blob/main/src/index.ts
    if (providedUrl === "about:blank") {
      showError('PROJECT_NOT_FOUND');
      return {} as QueryParams;
    }

    // Url has sp and projectId wasnt set before!
    const param : string = urlParams.get(PROJECT_PARAM) || "";
    const projectIdFromList = await getProjectFromDirectory(param);
    if (!projectIdFromList) {
      showError('PROJECT_NOT_FOUND');
      return {} as QueryParams;
    }

    queryParams.project = projectIdFromList;
  }

  const categoryParam : string = urlParams.get(CATEGORY_PARAM) || "";
  if (categoryParam.length > 0 && queryParams.categoryFilterEnabled) {
    queryParams.categoryFilter = categoryParam;
  }

  const questParam : string = urlParams.get("quest") || "";
  if (questParam.length > 0) {
    queryParams.quest = questParam;
  }

  if (urlParams.has(PARTY_PARAM) && queryParams.collaborationEnabled) {
    const party : string = urlParams.get(PARTY_PARAM) || "";
    const newUser = {
      name: getRandomElement(names),
      color: randomColor(),
      room: party,
    }
    setComponentData(PARTY_USER_STATE, newUser)
    setupPartyProvider(newUser)
    updateLocalUser(newUser);
  }

  return queryParams;
}
